module.exports = __webpack_public_path__ + "img/Utilization of Health Information Technology in Malaysia.22d382e8.jpg";